var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9C7.864 9 4 16 4 16C4 16 7.864 23 16 23C24.136 23 28 16 28 16C28 16 24.136 9 16 9Z",
    stroke: "currentColor",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 21C16.5878 21 17.6512 20.6774 18.5556 20.0731C19.4601 19.4687 20.1651 18.6098 20.5813 17.6048C20.9976 16.5998 21.1065 15.4939 20.8943 14.427C20.6821 13.3601 20.1583 12.3801 19.3891 11.6109C18.6199 10.8417 17.6399 10.3179 16.573 10.1057C15.5061 9.89346 14.4002 10.0024 13.3952 10.4187C12.3902 10.8349 11.5313 11.5399 10.9269 12.4444C10.3226 13.3488 10 14.4122 10 15.5C10 16.9587 10.5795 18.3576 11.6109 19.3891C12.6424 20.4205 14.0413 21 15.5 21Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.268 14C13.0911 14.4221 13 14.8753 13 15.333C13 15.7907 13.0911 16.2439 13.268 16.666C13.3943 17.0336 13.6258 17.3559 13.9337 17.5931C14.2416 17.8302 14.6124 17.9717 15 18",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.16408f5468460b3ccbbad93997c624b3.svg";
export { ForwardRef as ReactComponent };